export default {
  updateMaterial(state, payload = null) {
    state.material = payload;
  },

  updateModel(state, payload = null) {
    state.model = payload;
  },

  updateCount(state, payload = 1) {
    state.count = payload;
  },

  updateCountIncrease(state) {
    state.count++;
  },

  updateCountReduce(state) {
    state.count--;
  },

  updateCalculation(state, payload = null) {
    state.calculation = payload;
  },

  updateMaterials(state, {
    data,
    key,
  }) {
    state.materials[key] = data;
  },
}
